import { forwardRef } from 'react';
import { useAgentSelector } from '../../../hooks/useAgentStore';
import '../../../styles/abstract/variables.less';
import { SanitizedMarkedHtml } from '../../../utils/MarkedHtml';
import ChangeRequestAnalysis from '../ChangeRequestAnalysis/ChangeRequestAnalysis';
import ChangeRequestActions from '../ChangeRequestActions/ChangeRequestActions';

const ChangeRequestExportView = forwardRef<HTMLDivElement>((_, ref) => {
  const getPageMargins = () => {
    return `
      @page {
        margin: 1in 0.5in 1in 0.5in !important;
        size: landscape;
      }
    `;
  };

  const { data } = useAgentSelector((state) => state.changeRequest);

  const renderPreview = (markdownText: string) => {
    const sanitizedHtml = SanitizedMarkedHtml(markdownText);

    return (
      <div id="markdown-editor-preview">
        <div
          id="markdown-preview"
          dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
        />
      </div>
    );
  };

  return (
    <div ref={ref} id="change-request-export-view">
      <style>{getPageMargins()}</style>
      <style>
        {`
        @media print {
          .page-break-before {
            page-break-before: always;
          }
          .page-break-after {
            page-break-after: always;
          }
          .main-heading-change-request {
            margin: auto;
            text-align: center;
            font-size: 24px;
            font-weight: bold;
          }
          .heading-change-request {
            font-size: 20px;
            font-weight: bold;
            margin-bottom: 20px;
          }
          .request-detail-text-wrapper{
            border: 1px solid var(--neutral-color-5);
            border-radius: 8px;
            padding: 10px;
          }
        }
    `}
      </style>
      <h2 className="main-heading-change-request">
        {data?.result?.name}: Change Request Summary
      </h2>
      <br />
      <h2 className="heading-change-request">Request Details:</h2>

      <div className="request-detail-text-wrapper">
        {renderPreview(data?.result?.summary || '')}
      </div>
      <div className="page-break-before">
        <h2 className="heading-change-request">Checklist Items:</h2>
        <ChangeRequestAnalysis isPrintView={true} />
      </div>
      <div className="page-break-before">
        <h2 className="heading-change-request">Actions:</h2>
        <ChangeRequestActions isPrintView={true} />
      </div>
    </div>
  );
});

ChangeRequestExportView.displayName = 'ChangeRequestExportView';

export default ChangeRequestExportView;
